import { useAuth } from "@clerk/react";
import { CLERK_ENABLED } from "./authStyles";

interface RequireAuthResult {
  readonly requireAuth: (callback?: () => void) => boolean;
  readonly isSignedIn: boolean;
  readonly isLoaded: boolean;
}

function useClerkRequireAuth(): RequireAuthResult {
  const { isSignedIn, isLoaded } = useAuth();

  const requireAuth = (callback?: () => void): boolean => {
    if (!isLoaded) return false;
    if (!isSignedIn) return false;
    if (callback) callback();
    return true;
  };

  return { requireAuth, isSignedIn: isSignedIn ?? false, isLoaded };
}

const noRequireAuth: RequireAuthResult = {
  requireAuth: (cb?: () => void) => {
    if (cb) cb();
    return true;
  },
  isSignedIn: false,
  isLoaded: true,
};

export function useRequireAuth(): RequireAuthResult {
  const clerkResult = useClerkRequireAuth();
  if (!CLERK_ENABLED) return noRequireAuth;
  return clerkResult;
}
